import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'enx-shared-ui-agreements',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatCheckboxModule, ReactiveFormsModule, FormsModule, MatInputModule],
  templateUrl: './shared-ui-agreements.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedUiAgreementsComponent {
  showPrivacyPolicyInfo = input<boolean>(true);
  formGroup = input<FormGroup>();

  get newsletterControl(): FormControl<boolean> {
    return this.formGroup()!.get('newsletterAccepted') as FormControl<boolean>;
  }

  get termsAndConditionsControl(): FormControl<boolean> {
    return this.formGroup()!.get('termsAndConditionsAccepted') as FormControl<boolean>;
  }
}
